import React from "react"
import SEO, { SEOProps } from "components/SEO"
import { SearchState } from "react-instantsearch-core"
import { connectPagination } from "react-instantsearch-dom"
import { getFallbackCategoryMetaDescription } from "utils/seo/pageSpecific/getCategorySEOProps"
import { getFallbackMetaTitle } from "utils/seo/pageSpecific/fallbackSEOProps"

const SEOWithPaginationTitle = ({
	currentRefinement: currentPage,
	nbPages: numberOfPages,
	searchState,
	...props
}: Props) => {
	const titleWithoutPagination = props.title ?? getFallbackMetaTitle(props.countryCode)
	const titleWithPagination =
		currentPage > 1
			? `${titleWithoutPagination} (${currentPage}/${numberOfPages})`
			: titleWithoutPagination

	const canonicalAppendix = currentPage > 1 ? `?page=${currentPage}` : ""
	const descriptionWithOutPagination =
		props.description ??
		getFallbackCategoryMetaDescription(props.categoryName, props.countryCode)
	const descriptionWithPagination =
		currentPage > 1
			? `(${currentPage}/${numberOfPages}) ${descriptionWithOutPagination}`
			: descriptionWithOutPagination

	const excludeLanguageAlternates = Object.keys(searchState).length > 0

	return (
		<SEO
			{...props}
			title={titleWithPagination}
			excludeLanguageAlternates={excludeLanguageAlternates}
			canonicalAppendix={canonicalAppendix}
			description={descriptionWithPagination}
		/>
	)
}

interface Props extends SEOProps {
	currentRefinement: number
	nbPages: number
	searchState: SearchState
}

export default connectPagination(SEOWithPaginationTitle)
